// features/bookmarks/meta.ts — static tables for the bookmarks UI.

import type { IconName } from '@/icons';
import type { BookmarkType } from '@/core/models/bookmark';

export type TypeFilter = 'all' | BookmarkType;
export type SortId = 'recent' | 'oldest';

export interface TypeTab { id: TypeFilter; label: string; }

export const TYPE_TABS: TypeTab[] = [
  { id: 'all',       label: 'All' },
  { id: 'post',      label: 'Posts' },
  { id: 'thread',    label: 'Threads' },
  { id: 'people',    label: 'People' },
  { id: 'community', label: 'Communities' },
  { id: 'video',     label: 'Videos' },
  { id: 'article',   label: 'Articles' },
  { id: 'product',   label: 'Products' },
];

export interface SortOption { id: SortId; label: string; }

export const SORTS: SortOption[] = [
  { id: 'recent', label: 'Most Recent' },
  { id: 'oldest', label: 'Oldest' },
];

export interface TypeMetaEntry { icon: IconName; label: string; }

// Item-type icons are differentiated by GLYPH only; color is the teal accent
// (theme.color.accentCyan) applied at the consuming component. No per-type tone.
export const TYPE_META: Record<BookmarkType, TypeMetaEntry> = {
  post:      { icon: 'file-text', label: 'Post' },
  thread:    { icon: 'list',      label: 'Thread' },
  people:    { icon: 'user',      label: 'People' },
  community: { icon: 'users',     label: 'Community' },
  video:     { icon: 'video',     label: 'Video' },
  article:   { icon: 'newspaper', label: 'Article' },
  product:   { icon: 'package',   label: 'Product' },
};
